import {Component, Input} from '@angular/core';
import {WordpressCheckComponent} from '../../components/wordpress-check/wordpress-check.component';
import {CommonModule} from '@angular/common';


type Styling = {
  backgroundColor: string;
  color: string;
};

@Component({
  selector: 'app-security-check',
  standalone: true,
  imports: [WordpressCheckComponent, CommonModule],
  templateUrl: './security-check.component.html',
  styleUrl: './security-check.component.css'
})
export class SecurityCheckComponent {
  @Input() securityData:any = {};

}
